import http from '@/utils/http';
import i18n from '@/main';

const baseUrl = '/pesquisa-inteligente';

export default {
    realizarPesquisaHome(filtro) {
        return http.get({
            url: baseUrl + `?filtro=${filtro}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.realizandoPesquisa')
        });
    },

    realizarPesquisaHomeParaguay(filtro) {
        return http.get({
            url: baseUrl + `/paraguay?filtro=${filtro}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.realizandoPesquisa')
        });
    },

    realizarPesquisaHomeArgentina(filtro) {
        return http.get({
            url: baseUrl + `/argentina?filtro=${filtro}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.realizandoPesquisa')
        });
    },

    realizarPesquisaTerritorios(filtro) {
        return http.get({
            url: baseUrl + `/territorios?filtro=${filtro}`,
            lockScreen: true,
            lockMessage: 'Realizando pesquisa em territórios'
        });
    }
};
